import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { Alert, Flex } from "antd";

import "../../shared/css/basicStyles.css";
import { useNavigate, useSearchParams } from "react-router-dom";

const EdificeAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [code] = useState(searchParams.get("code"));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadToken = async () => {
      if (code) {
        navigate(
          `/v2/edifice?code=${code}&url=${encodeURI(
            searchParams.get("url") || ""
          )}`
        );
      } else {
        var url =
          window.location !== window.parent.location
            ? document.referrer
            : document.location.origin;

        if (url && url.length > 0) {
          if (url.endsWith("/")) url = url.slice(0, -1);

          // Sinon, demander le code oauth
          window.open(
            `${url}/auth/oauth2/auth?response_type=code&state=blip&scope=userinfo&client_id=nabook-sso&redirect_uri=https://webapp.nabook.co/v2/edifice/auth?url=${encodeURI(
              url
            )}`,
            "_self"
          );
        } else {
          setError(
            "L'URL de redirection est vide. Veuillez vérifier l'URL de l'application."
          );
          console.log(
            "❌ => URL is empty",
            document.referrer,
            document.location.origin
          );
        }
      }
    };
    loadToken();
  }, [code, navigate, searchParams]);

  return (
    <div className="mainContainer">
      <Flex
        style={{
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
          height: "100vh",
        }}
        vertical
        gap={24}
      >
        <CircularProgress color="inherit" />
        <div>{"Authentification en cours..."}</div>
        {error && (
          <div
            style={{
              marginTop: 20,
            }}
          >
            <Alert message={error} type="error" />
          </div>
        )}
      </Flex>
    </div>
  );
};

export default EdificeAuth;
